module.exports = __webpack_public_path__ + "img/under-construction.230a44c1.webp";